// extracted by mini-css-extract-plugin
export default {"achievement-rank__container":"styles_achievement-rank__container__tyfUP","rank-text__container":"styles_rank-text__container__TeldW","rank__text":"styles_rank__text__AcL91"};